import axios from 'axios'

export default {
    /**
     * 获取验证码
     */
    async getIdentify(data, callback) {
        var res = await axios({
            method: 'post',
            url: 'IdentifyingAction!serchIdentifying',
            data: data,
        });

        // 执行回调
        callback(res);
    },

    /**
     * 用户登录
     */
    async login(data, callback) {
        var res = await axios({
            method: 'post',
            url: 'LoginAction!login',
            data: data,
        });

        // 执行回调
        callback(res);
    },

}